export default __webpack_public_path__ + "static/media/photo--sm--leena-4.ee4b33ef.jpg";